// packages/contract/fixtures/new-clinic.ts
//
// NOT ENOUGH DATA. A dental clinic scanned two days ago. Eleven mentions in
// total, so every derived metric is suppressed. Several actions have no
// measured basis for a lift. Several questions have zero hits on every engine.
// One real history point, two projected nulls. Exists to prove the UI can say
// "we do not know yet" without apologising.

import type { LatestSnapshot } from '../contract';

export const newClinic: LatestSnapshot = {
  business: {
    id: 'new-clinic',
    name: 'Riverside Dental',
    domain: 'riversidedental.co',
    vertical: 'Dental clinic',
    city: 'Petaling Jaya',
    state: 'prospect',
    plan: null,
  },
  snapshot: {
    id: 'snap-clinic-2026-07',
    businessId: 'new-clinic',
    capturedAt: '2026-07-07',
    gated: false,
    gateReasons: [],
    total: 34,
    level: 2,
    levelName: 'Finding your feet',
    plusMinus: 8,
    samplesPerCell: 3,
    previousTotal: null,
    pillars: [
      { key: 'answer_presence', label: 'When people ask AI', kind: 'result', score: 8, max: 35, band: 'weak' },
      { key: 'search_rank', label: 'When people search Google', kind: 'result', score: 9, max: 20, band: 'getting_there' },
      { key: 'site', label: 'Pages AI can read', kind: 'lever', score: 6, max: 15, band: 'getting_there' },
      { key: 'sources', label: 'Where AI hears about you', kind: 'lever', score: 5, max: 15, band: 'weak' },
      { key: 'reputation', label: 'What your customers say', kind: 'lever', score: 6, max: 15, band: 'getting_there' },
    ],
    headline: {
      questionsTested: 12,
      mentionsTotal: 11,
      namedRate: 0.14,
      linkRate: 0.05,
      bestGooglePosition: 5,
      sentiment: null,
      sentimentSuppressed: true,
      plainSummary:
        'We have only just started watching how AI talks about you. There are not enough mentions yet to read a trend, so treat this as your starting line, not a verdict.',
    },
    questions: [
      {
        id: 'q-cl-1', text: 'best dentist in Petaling Jaya',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 1, position: 5 },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 1, position: 4 },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 5, localPack: 3, siteAnswers: true, actionId: 'a-cl-1',
      },
      {
        id: 'q-cl-2', text: 'emergency dentist near me PJ',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: null, localPack: null, siteAnswers: false, actionId: 'a-cl-2',
      },
      {
        id: 'q-cl-3', text: 'teeth whitening Petaling Jaya',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 1, position: 6 },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 8, localPack: null, siteAnswers: true, actionId: 'a-cl-1',
      },
      {
        id: 'q-cl-4', text: 'invisalign clinic PJ',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: null, localPack: null, siteAnswers: false, actionId: 'a-cl-3',
      },
      {
        id: 'q-cl-5', text: 'dentist open on weekends Petaling Jaya',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: null, localPack: null, siteAnswers: false, actionId: 'a-cl-2',
      },
      {
        id: 'q-cl-6', text: 'children dentist Petaling Jaya',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 1, position: 5 },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 11, localPack: null, siteAnswers: false, actionId: null,
      },
    ],
    rivals: [
      {
        name: 'Smile Studio PJ', domain: 'smilestudiopj.com',
        winsQuestionIds: ['q-cl-2', 'q-cl-4', 'q-cl-5'],
        whatTheyHave: 'A page listing weekend and emergency hours that AI quotes. You have none.',
        reviewCount: 430, reviewRating: 4.8, total: 58, previousTotal: null,
      },
      {
        name: 'Damansara Dental', domain: 'damansaradental.my',
        winsQuestionIds: ['q-cl-4'],
        whatTheyHave: 'A dedicated Invisalign page with prices. Yours does not mention Invisalign at all.',
        reviewCount: 260, reviewRating: 4.6, total: 47, previousTotal: null,
      },
    ],
    setup: {
      site: [
        { label: 'Your website lists your services', status: 'ok', detail: 'General dentistry and whitening are covered.' },
        { label: 'A page for emergency and weekend visits', status: 'missing', detail: 'A common question with no answer on your site.' },
        { label: 'A page for Invisalign', status: 'missing' },
        { label: 'Your address and hours match across the web', status: 'ok' },
      ],
      sources: [
        { label: 'Listed on a health directory AI reads', status: 'warn', detail: 'On one, rivals are on three.' },
        { label: 'Mentioned by local writers', status: 'missing' },
      ],
      reputation: [
        { label: 'Google reviews', value: '74', comparison: 'Smile Studio has 430' },
        { label: 'Average rating', value: '4.7 stars', comparison: 'Strong, keep it up' },
        { label: 'Reviews you have replied to', value: '40%', comparison: 'Room to improve' },
      ],
      plainSummary:
        'You are new to us, so read this lightly. What we can already see: your services are on your site, but the questions about emergencies, weekends and Invisalign have no page for AI to point to.',
    },
    connections: [
      {
        channel: 'website', label: 'Your website', status: 'not_connected',
        method: 'We publish pages through your CMS, or a one-time Oura snippet.',
        detail: 'Not connected yet. Needed before we can add your emergency or Invisalign pages for you.',
      },
      {
        channel: 'listings', label: 'Directories & listings', status: 'not_connected',
        method: 'We claim and manage health directories on your behalf.',
        detail: 'Not connected yet.',
      },
    ],
    actions: [
      {
        id: 'a-cl-1', title: 'Fill out your Google profile completely', channel: 'google_business',
        body: 'A complete profile gives AI more of you to repeat. Yours is mostly there; finishing it is a quick win.',
        estLift: 4, lever: 'sources', helps: ['ai', 'google'], effort: 'We finish it, you confirm',
        owner: 'oura', draftReady: false, draftCount: null, status: 'todo',
      },
      {
        id: 'a-cl-2', title: 'Add a page for emergency and weekend visits', channel: 'website',
        body: 'People ask AI for emergency and weekend dentists. You have no page for it, so a rival gets named. We do not have enough data yet to promise a number, but this is a clear gap.',
        estLift: null, lever: 'site', helps: ['ai', 'google'], effort: 'We draft it, you approve',
        owner: 'oura', draftReady: true, draftCount: 1, status: 'todo',
        steps: [
          'We write a page listing your weekend and emergency hours and how to reach you fast.',
          'You approve the draft below.',
          'We publish it. Because you are new to us, we will only be able to estimate the lift after a few weekly checks.',
        ],
        draftPreview:
          'Emergency & weekend dental care in Petaling Jaya\n\nOpen Saturdays 9am–5pm and Sundays 10am–2pm. Chipped a tooth or in pain? Call us on the number at the top and we hold same-day slots for emergencies. Walk-ins seen between booked patients.',
      },
      {
        id: 'a-cl-3', title: 'Add an Invisalign page with prices', channel: 'website',
        body: 'Your site does not mention Invisalign. A page about it would let AI bring you up for those searches. Too early for us to estimate the lift.',
        estLift: null, lever: 'site', helps: ['ai'], effort: 'We draft it, you approve',
        owner: 'oura', draftReady: false, draftCount: null, status: 'todo',
      },
      {
        id: 'a-cl-4', title: 'Reply to your recent reviews',
        body: 'You have replied to 40% of your reviews. More replies tell AI you are active.',
        estLift: null, lever: 'reputation', helps: ['ai'], effort: '15 minutes',
        owner: 'client', draftReady: false, draftCount: null, status: 'todo',
      },
    ],
    feed: [],
    history: [
      { month: '2026-07', total: 34, level: 2, projected: false, note: 'Your first check.' },
      { month: '2026-08', total: null, level: null, projected: true, note: 'A clinic like yours that adds the missing pages typically reaches the low 40s.' },
      { month: '2026-09', total: null, level: null, projected: true, note: 'The high 40s is common once a second source picks you up.' },
    ],
  },
};
